import moment from "moment";
import { deviceType, carType } from "constant";
import { isValidLocation } from "_helperFunctions/isValidLocation";


export let staleTimeInMinutes = 15;  // default cutoff = 15 minutes ago
export var isCarInUse = function (car, includeNotPlaying, includeNoComm, includeCharging) {
    // If marked out-of-service, never count as in use
    if (!includeNotPlaying && (car?.CarType === carType.outOfService))
        return false;

    // Must have reported position within last XX minutes to count
    var ageInMinutes = moment().diff(moment.utc(car?.LastLocationUpdateInUtc), 'minutes'); // JFG: I don't think .utc is necessary here
    if (!includeNoComm && (ageInMinutes > staleTimeInMinutes))
        return false;

    if (car?.DevType !== deviceType.FT || car?.DevType !== deviceType.WT) {
        // For all cars, must be off charge and have a valid lat/long
        if (
            // !(includeCharging && featuresResortEdition()) && 
            (car?.IsCharging || !isValidLocation(car?.Latitude, car?.Longitude)))
            return false;

        // if (datacontext.featuresResortEdition()) {
        //     // For regular and special needs car, must have a guest name and/or suite assigned to count as "in use"
        //     if (!includeNotPlaying && (car.CarType !== vc.carType.marshal) && (car.CarType !== vc.carType.bevcart))
        //       if (!car.PlayerName1 && !car.PlayerName2)
        //           return false;
        // }
        else {
            var holeLocation = {
                unknown: 0,
                betweenHoles: 1,
                tee: 2,
                fairway: 3,
                green: 4
            };
            // For regular golfers and special needs, must be on a hole to count as "in use"
            if (!includeNotPlaying && (car?.HoleLocation === holeLocation.unknown) && (car?.CarType !== carType.marshal) && (car?.CarType !== carType.bevcart))
                return false; // not on hole, not a marshal, not a beverage cart === not in use
        }
    }
    else {
        if (car?.IsCharging) {
            return includeNotPlaying;
        }
        if (!isValidLocation(car?.Latitude, car?.Longitude)) {
            return false;
        }
    }

    return true;      // in use!
};